import { Helmet } from '@dr.pogodin/react-helmet';
import { Link } from 'react-router';
import NoticeSiteHasBeenArchived from '../common/lib/NoticeSiteHasBeenArchived';
import PageNotFound from '../common/lib/PageNotFound';
import type { MultiLang } from '../config';
import Functions from '../functions';
import './assets/pubmedpdf.css';
import PubmedPdfBreadcrumbs from './lib/PubmedPdfBreadcrumbs';
import PubmedPdfUtils, { type PubmedPdfBreadcrumbsData } from './lib/PubmedPdfUtils';

interface Props {
    lang: MultiLang;
    year: number;
}

const PubmedPdfJournalsByYear = (props: Props) => {
    const { lang, year } = props;
    const name = PubmedPdfUtils.getName();
    const mtitle = Functions.mlang(name, lang);
    const journals = PubmedPdfUtils.getJournalsByYear(year);
    if (journals.length === 0) {
        return <PageNotFound lang={lang} />;
    }
    const breadcrumbs: PubmedPdfBreadcrumbsData[] = [
        { id: `y.${year}`, name: `${year}`, link: PubmedPdfUtils.getYearUrl(year, 0) },
    ];
    return (
        <div className="pubmedpdf">
            <Helmet>
                <title>
                    {mtitle} - {Functions.siteTitle(lang)}
                </title>
            </Helmet>
            <h3>{mtitle}</h3>
            <NoticeSiteHasBeenArchived lang={lang} />
            <PubmedPdfBreadcrumbs lang={lang} breadcrumbs={breadcrumbs} />
            <hr />
            <div className="journals">
                <div className="journal-group">
                    {journals.map((journal) => {
                        const name = Functions.mlang(journal.name, lang);
                        const nameShort = name.slice(0, 20) + (name.length > 20 ? '...' : '');
                        return (
                            <div className="journal" key={journal.id}>
                                <Link to={PubmedPdfUtils.getYearUrl(year, journal.id)} title={name}>
                                    {nameShort}
                                </Link>{' '}
                                ({journal.count})
                            </div>
                        );
                    })}
                </div>
            </div>
            <hr />
        </div>
    );
};

export default PubmedPdfJournalsByYear;
